
import CrossingFreezePopup from './crossingfreezepopup'

export default CrossingFreezePopup;